import { css } from '@emotion/css';
import { A } from '@solidjs/router';
import { Component } from 'Shared/frontend/widgets/Component';
import { LinkLayout } from 'Shared/model/Components';
import { theme } from 'Shared/frontend/SettingsProvider';
import { InsideLinkContext, useInsideLink } from 'Shared/frontend/widgets/InsideLinkContext';
import { Match, Switch } from 'solid-js';

export function Link(P:LinkLayout)
{
	const linkStyle = css(
		theme().a
	);

	const insideLink = useInsideLink();

//FIXME clicking on a '#widget2' twice doesn't work as the link is appended to the URL. 

	return (
		<Switch>
			<Match when={P.isAnchor && insideLink()}>
				<span id={P.anchor}/>
			</Match>
			<Match when={P.isAnchor}>
				<a id={P.anchor}/>
			</Match>
			<Match when={insideLink()}>
				<span class={linkStyle}>
					<Component {...P.content} />
				</span>
			</Match>
			<Match when={true}>
				<A href={P.link ?? ''} class={linkStyle} target={!P.openInSameWindow ? '_blank' : undefined}>
					<InsideLinkContext.Provider value={() => true}>
						<Component {...P.content} />
					</InsideLinkContext.Provider>
				</A>
			</Match>
		</Switch>
	);
}

